import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-retrieve-data-terms',
  templateUrl: './dialog-retrieve-data.component.html',
  styleUrls: ['./dialog-retrieve-data.component.scss'],
})
export class DialogRetrieveDataComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogRetrieveDataComponent>
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  retrieveData() {
    this.dialogRef.close(true);
  }

  dontRetrieveData() {
    this.dialogRef.close(false);
  }
}
